import { capitalize } from 'vue';

import FeeType from '@/common/enums/FeeType.enum';
import i18n from '@/vueI18n';

export interface IMarginTypesOption {
  type: FeeType;
  name: string;
  sequence: number;
}

export default class MarginTypesOptions {
  static FIXED = {
    type: FeeType.Fixed,
    name: 'messages.fixedCPM',
    sequence: 1, // sequence value
  };

  static FIXED_MARKUP = {
    type: FeeType.FixedMarkup,
    name: 'messages.fixedMarkup',
    sequence: 1,
  };

  static PERCENT = {
    type: FeeType.Percent,
    name: 'names.percentage',
    sequence: 1,
  };

  static options(): Array<IMarginTypesOption> {
    return [MarginTypesOptions.FIXED, MarginTypesOptions.FIXED_MARKUP, MarginTypesOptions.PERCENT];
  }

  static optionsFormatted(): Array<IMarginTypesOption> {
    return MarginTypesOptions.options().map((o) => ({
      ...o,
      name: capitalize(i18n.global.t(o.name)),
    }));
  }
}
